// source: shop.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.pb.shop.ProductInfo', null, global);
goog.exportSymbol('proto.com.pb.shop.ProductList', null, global);
goog.exportSymbol('proto.com.pb.shop.Specification', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.shop.ProductList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.pb.shop.ProductList.repeatedFields_, null);
};
goog.inherits(proto.com.pb.shop.ProductList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.shop.ProductList.displayName = 'proto.com.pb.shop.ProductList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.shop.ProductInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.pb.shop.ProductInfo.repeatedFields_, null);
};
goog.inherits(proto.com.pb.shop.ProductInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.shop.ProductInfo.displayName = 'proto.com.pb.shop.ProductInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.pb.shop.Specification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.pb.shop.Specification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.pb.shop.Specification.displayName = 'proto.com.pb.shop.Specification';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.pb.shop.ProductList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.shop.ProductList.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.shop.ProductList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.shop.ProductList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.shop.ProductList.toObject = function(includeInstance, msg) {
  var f, obj = {
    productInfoList: jspb.Message.toObjectList(msg.getProductInfoList(),
    proto.com.pb.shop.ProductInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.shop.ProductList}
 */
proto.com.pb.shop.ProductList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.shop.ProductList;
  return proto.com.pb.shop.ProductList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.shop.ProductList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.shop.ProductList}
 */
proto.com.pb.shop.ProductList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.pb.shop.ProductInfo;
      reader.readMessage(value,proto.com.pb.shop.ProductInfo.deserializeBinaryFromReader);
      msg.addProductInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.shop.ProductList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.shop.ProductList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.shop.ProductList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.shop.ProductList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.com.pb.shop.ProductInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProductInfo product_info = 1;
 * @return {!Array<!proto.com.pb.shop.ProductInfo>}
 */
proto.com.pb.shop.ProductList.prototype.getProductInfoList = function() {
  return /** @type{!Array<!proto.com.pb.shop.ProductInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.pb.shop.ProductInfo, 1));
};


/**
 * @param {!Array<!proto.com.pb.shop.ProductInfo>} value
 * @return {!proto.com.pb.shop.ProductList} returns this
*/
proto.com.pb.shop.ProductList.prototype.setProductInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.com.pb.shop.ProductInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.pb.shop.ProductInfo}
 */
proto.com.pb.shop.ProductList.prototype.addProductInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.com.pb.shop.ProductInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.pb.shop.ProductList} returns this
 */
proto.com.pb.shop.ProductList.prototype.clearProductInfoList = function() {
  return this.setProductInfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.pb.shop.ProductInfo.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.shop.ProductInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.shop.ProductInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.shop.ProductInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.shop.ProductInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    pId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pNowPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    pOriginalPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    pNumOfBuy: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pPic1: jspb.Message.getFieldWithDefault(msg, 6, ""),
    specificationList: jspb.Message.toObjectList(msg.getSpecificationList(),
    proto.com.pb.shop.Specification.toObject, includeInstance),
    shelfIdList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.shop.ProductInfo}
 */
proto.com.pb.shop.ProductInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.shop.ProductInfo;
  return proto.com.pb.shop.ProductInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.shop.ProductInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.shop.ProductInfo}
 */
proto.com.pb.shop.ProductInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPNowPrice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPOriginalPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPNumOfBuy(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPPic1(value);
      break;
    case 7:
      var value = new proto.com.pb.shop.Specification;
      reader.readMessage(value,proto.com.pb.shop.Specification.deserializeBinaryFromReader);
      msg.addSpecification(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addShelfId(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.shop.ProductInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.shop.ProductInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.shop.ProductInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.shop.ProductInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPNowPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getPOriginalPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getPNumOfBuy();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getPPic1();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSpecificationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.com.pb.shop.Specification.serializeBinaryToWriter
    );
  }
  f = message.getShelfIdList();
  if (f.length > 0) {
    writer.writePackedInt32(
      8,
      f
    );
  }
};


/**
 * optional int32 p_id = 1;
 * @return {number}
 */
proto.com.pb.shop.ProductInfo.prototype.getPId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setPId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string p_name = 2;
 * @return {string}
 */
proto.com.pb.shop.ProductInfo.prototype.getPName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setPName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional float p_now_price = 3;
 * @return {number}
 */
proto.com.pb.shop.ProductInfo.prototype.getPNowPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setPNowPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float p_original_price = 4;
 * @return {number}
 */
proto.com.pb.shop.ProductInfo.prototype.getPOriginalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setPOriginalPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 p_num_of_buy = 5;
 * @return {number}
 */
proto.com.pb.shop.ProductInfo.prototype.getPNumOfBuy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setPNumOfBuy = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string p_pic_1 = 6;
 * @return {string}
 */
proto.com.pb.shop.ProductInfo.prototype.getPPic1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setPPic1 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated Specification specification = 7;
 * @return {!Array<!proto.com.pb.shop.Specification>}
 */
proto.com.pb.shop.ProductInfo.prototype.getSpecificationList = function() {
  return /** @type{!Array<!proto.com.pb.shop.Specification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.pb.shop.Specification, 7));
};


/**
 * @param {!Array<!proto.com.pb.shop.Specification>} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
*/
proto.com.pb.shop.ProductInfo.prototype.setSpecificationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.com.pb.shop.Specification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.pb.shop.Specification}
 */
proto.com.pb.shop.ProductInfo.prototype.addSpecification = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.com.pb.shop.Specification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.clearSpecificationList = function() {
  return this.setSpecificationList([]);
};


/**
 * repeated int32 shelf_id = 8;
 * @return {!Array<number>}
 */
proto.com.pb.shop.ProductInfo.prototype.getShelfIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.setShelfIdList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.addShelfId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.pb.shop.ProductInfo} returns this
 */
proto.com.pb.shop.ProductInfo.prototype.clearShelfIdList = function() {
  return this.setShelfIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.pb.shop.Specification.prototype.toObject = function(opt_includeInstance) {
  return proto.com.pb.shop.Specification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.pb.shop.Specification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.shop.Specification.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pictures: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    specificationName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    stock: jspb.Message.getFieldWithDefault(msg, 6, 0),
    specificationPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.pb.shop.Specification}
 */
proto.com.pb.shop.Specification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.pb.shop.Specification;
  return proto.com.pb.shop.Specification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.pb.shop.Specification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.pb.shop.Specification}
 */
proto.com.pb.shop.Specification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPictures(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpecificationName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStock(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSpecificationPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.pb.shop.Specification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.pb.shop.Specification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.pb.shop.Specification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.pb.shop.Specification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPictures();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSpecificationName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStock();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getSpecificationPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.com.pb.shop.Specification.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.Specification} returns this
 */
proto.com.pb.shop.Specification.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string pictures = 2;
 * @return {string}
 */
proto.com.pb.shop.Specification.prototype.getPictures = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.shop.Specification} returns this
 */
proto.com.pb.shop.Specification.prototype.setPictures = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 product_id = 3;
 * @return {number}
 */
proto.com.pb.shop.Specification.prototype.getProductId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.Specification} returns this
 */
proto.com.pb.shop.Specification.prototype.setProductId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string specification_name = 4;
 * @return {string}
 */
proto.com.pb.shop.Specification.prototype.getSpecificationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.pb.shop.Specification} returns this
 */
proto.com.pb.shop.Specification.prototype.setSpecificationName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 stock = 6;
 * @return {number}
 */
proto.com.pb.shop.Specification.prototype.getStock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.Specification} returns this
 */
proto.com.pb.shop.Specification.prototype.setStock = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional float specification_price = 7;
 * @return {number}
 */
proto.com.pb.shop.Specification.prototype.getSpecificationPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.pb.shop.Specification} returns this
 */
proto.com.pb.shop.Specification.prototype.setSpecificationPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


goog.object.extend(exports, proto.com.pb.shop);
